import React, { useState } from 'react';
import { toast } from 'sonner';
import { Loader2, ShieldAlert } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { useAuth } from '../../context/AuthContext';
import { runAiJob } from '../../lib/aiJob';

const List = ({ title, items }) => (items?.length ? (
  <div><p className="mb-1 text-xs font-semibold text-amber-300">{title}</p><ul className="space-y-1 text-sm text-slate-300">{items.map((x, i) => <li key={i}>• {x}</li>)}</ul></div>
) : null);

// Hecho-por-hecho defense against a disciplinary complaint, adapted to the fiscal judicial in charge
export const DenunciaStrategyDialog = ({ matter, onClose, onUpdated }) => {
  const { api } = useAuth();
  const [d, setD] = useState(matter.denuncia_strategy || null);
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try { setD(await runAiJob(api, `/courts/matters/${matter.id}/denuncia-strategy`, {}, { timeout: 240000 })); onUpdated(); } catch (e) { toast.error(e.message); } finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="denuncia-strategy-dialog" className="max-h-[90vh] max-w-3xl overflow-y-auto border-slate-700 bg-slate-900 text-white">
        <DialogHeader><DialogTitle className="flex items-center gap-2"><ShieldAlert className="h-5 w-5 text-rose-300" />Estrategia contra la denuncia</DialogTitle></DialogHeader>
        <button data-testid="denuncia-strategy-run" onClick={run} disabled={busy} className="flex w-fit items-center gap-2 rounded-full bg-amber-500 px-4 py-2 text-sm font-semibold text-slate-950 disabled:opacity-60">
          {busy && <Loader2 className="h-4 w-4 animate-spin" />}{busy ? 'Fidem analiza cada hecho...' : d ? 'Regenerar estrategia' : 'Generar estrategia'}
        </button>
        {d && (
          <div data-testid="denuncia-strategy-result" className="space-y-4">
            {d.fiscal && <p className="text-xs text-emerald-300">Ajustada a {d.fiscal.judge_name} ({d.fiscal.court}{d.fiscal.estilo ? ` · ${d.fiscal.estilo}` : ''})</p>}
            <p className="text-sm text-slate-200">{d.resumen}</p>
            {d.como_investiga_el_fiscal && <p className="rounded-xl border border-sky-500/30 bg-sky-500/5 p-3 text-xs text-sky-100"><b>Cómo investigará el fiscal:</b> {d.como_investiga_el_fiscal}</p>}
            <div className="space-y-2">
              {(d.hechos || []).map((h, i) => (
                <div key={i} data-testid={`denuncia-hecho-${i}`} className="rounded-xl border border-slate-700 p-3 text-sm">
                  <p className="font-semibold text-white">{i + 1}. {h.hecho}</p>
                  <p className="mt-1 text-slate-300"><b className="text-emerald-300">Cómo rebatirlo:</b> {h.como_rebatir}</p>
                  <p className="text-slate-400"><b>Prueba:</b> {h.prueba} · <b>Norma:</b> {h.norma}</p>
                </div>
              ))}
            </div>
            <List title="Excepciones" items={d.excepciones} />
            <List title="Riesgos" items={d.riesgos} />
            <List title="Plan" items={d.plan} />
            {d.tono_respuesta && <p className="text-xs text-slate-400"><b>Tono de la respuesta:</b> {d.tono_respuesta}</p>}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
